module.exports = __webpack_public_path__ + "media/svg-new/icon-pdf-e446b587.svg";